<template>
  <Section :title="courses.title">
    <div class="education-item" v-for="(c, i) in courses.courses" :key="i">
      <div>
        <div class="degree">{{ c.degree }}</div>
        <div class="school">
          <a v-if="c.url" :href="c.url" target="_blank" class="link">
            {{ c.institution }}
          </a>
          <span v-else>{{ c.institution }}</span>
        </div>
      </div>
      <div class="date">{{ c.date }}</div>
    </div>
  </Section>
</template>

<script>
import Section from "./Section";

export default {
  name: "Education",
  components: { Section },
  props: {
    courses: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.education-item {
  margin-bottom: 4mm;
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 3mm;
}

.education-item:last-child {
  margin-bottom: 0;
}

.degree {
  font-size: 9pt;
  font-weight: 700;
  line-height: 1.3;
}

.school {
  font-size: 8pt;
  color: #666;
  margin-top: 1mm;
}

.school .link {
  color: #666;
  text-decoration: none;
}

.school .link:hover {
  color: #000;
  text-decoration: underline;
}

.date {
  font-size: 8pt;
  color: #000;
  text-align: right;
  font-weight: 400;
}

@media screen and (max-width: 202mm) {
  .education-item {
    grid-template-columns: 1fr;
    gap: 1mm;
  }
  
  .date {
    text-align: left;
  }
}
</style>
